import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import AmbuNetLogo from '../../../assets/images/ambunetLogo.png'

export default function Footer() {
  return (
    <Stack
      component="footer"
      direction="row"
      alignItems="center"
      justifyContent="center"
      gap={1}
      sx={{ py: 3, color: 'text.secondary' }}
    >
      <Typography variant="caption">Powered by</Typography>
      <Box component="img" src={AmbuNetLogo} alt="" sx={{ height: 22 }} />
      <Typography variant="caption" fontWeight={600}>
        AmbuNet&reg;
      </Typography>
    </Stack>
  )
}
